<script lang="ts" setup></script>

<template>
  <v-layout>
    <v-main class="empty-layout">
      <NuxtPage :page-key="(route) => route.fullPath" />
    </v-main>
  </v-layout>
</template>

<style lang="scss" scoped></style>
